import { createContext, useState } from "react";

const advancedContext = createContext({
  loading: false,
  setLoading: () => {},
  indicatorsModalOpen: false,
  setIndicatorsModalOpen: () => {},
  modalLoading: false,
  setModalLoading: () => {},
  questionModalOpen: false,
  setQuestionModalOpen: () => {},
  openDeleteWatchlistModal: false,
  showWatchlistsModalOpen: () => {},
  setShowWatchlistsModalOpen: false,
  setOpenDeleteWatchlistModal: () => {},
  type: "",
  setType: () => {},
  strategiesModal: [],
  setStrategiesModal: () => {},
  searchModal: "",
  setSearchModal: () => {},
  questionModalImage: "",
  setQuestionModalImage: () => {},
  signalsDataAdvanced: [],
  setSignalsDataAdvanced: () => {},
  indicatoresArray: [],
  setIndicatoresArray: () => {},
  deleteModalOpen: false,
  setDeleteModalOpen: () => {},
  forceRender: false,
  setForceRender: () => {},
  signalsDataBeforeSort: [],
  setSignalsDataBeforeSort: () => {},
  singleSignalModal: [],
  setSingleSignalModal: () => {},
  advancedCCXTModal: false,
  setAdvancedCCXTModal: () => {},
  allDataAdvanced: [],
  setAllDataAdvanced: () => {},
  allDataAdvanced_signals: [],
  setAllDataAdvanced_signals: () => {},
  allDataAdvanced_selected_items: [],
  setAllDataAdvanced_selected_items: () => {},
  indicatore: "",
  setIndicatore: () => {},
});

export const AdvancedProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [indicatorsModalOpen, setIndicatorsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [questionModalOpen, setQuestionModalOpen] = useState(false);
  const [showWatchlistsModalOpen, setShowWatchlistsModalOpen] = useState(false);
  const [questionModalImage, setQuestionModalImage] = useState("");
  const [type, setType] = useState("all");
  const [searchModal, setSearchModal] = useState("");
  const [strategiesModal, setStrategiesModal] = useState([]);
  // const [signalsDataAdvanced, setSignalsDataAdvanced] = useState([]);
  const [indicatoresArray, setIndicatoresArray] = useState([]);
  const [forceRender, setForceRender] = useState(false);
  const [signalsDataBeforeSort, setSignalsDataBeforeSort] = useState([]);

  // @desc: for advanced watchlist
  const [openDeleteWatchlistModal, setOpenDeleteWatchlistModal] =
    useState(false);

  // @desc: for send name and other coin info to beginner modal
  const [singleSignalModal, setSingleSignalModal] = useState([]);
  const [advancedCCXTModal, setAdvancedCCXTModal] = useState(false);
  const [allDataAdvanced, setAllDataAdvanced] = useState([]);
  const [allDataAdvanced_signals, setAllDataAdvanced_signals] = useState([]);
  const [allDataAdvanced_selected_items, setAllDataAdvanced_selected_items] =
    useState([]);

  // @desc: for send name and other coin info to beginner modal
  const [indicatore, setIndicatore] = useState("");

  let array = [];

  // advanced context value
  const advancedValue = {
    array,
    loading,
    setLoading,
    indicatorsModalOpen,
    setIndicatorsModalOpen,
    questionModalOpen,
    setQuestionModalOpen,
    modalLoading,
    setModalLoading,
    type,
    setType,
    strategiesModal,
    setStrategiesModal,
    searchModal,
    setSearchModal,
    questionModalImage,
    setQuestionModalImage,
    // signalsDataAdvanced,
    // setSignalsDataAdvanced,
    indicatoresArray,
    setIndicatoresArray,
    deleteModalOpen,
    setDeleteModalOpen,
    forceRender,
    setForceRender,
    signalsDataBeforeSort,
    setSignalsDataBeforeSort,
    singleSignalModal,
    setSingleSignalModal,
    advancedCCXTModal,
    setAdvancedCCXTModal,
    allDataAdvanced,
    setAllDataAdvanced,
    allDataAdvanced_signals,
    setAllDataAdvanced_signals,
    allDataAdvanced_selected_items,
    setAllDataAdvanced_selected_items,
    openDeleteWatchlistModal,
    setOpenDeleteWatchlistModal,
    showWatchlistsModalOpen,
    setShowWatchlistsModalOpen,
    indicatore,
    setIndicatore,
  };

  return (
    <advancedContext.Provider value={advancedValue}>
      {children}
    </advancedContext.Provider>
  );
};

export default advancedContext;
